import 'focus-visible';
import Sticky from './Sticky';
import Drupal from './Drupal';
import Header from './Header';
import Toolbar from './Toolbar';
import HomeHero from './HomeHero';
import Navigation from './Navigation';
import DDTemplates from './DDTemplates';
import SmartFooter from './SmartFooter';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
import FetchSourceImages from './FetchSourceImages';
import AccordionWrap from './AccordionWrap';
import AccordionFix from './AccordionFix';
import AccordionContainer from './AccordionContainer';
import BackgroundImage from './BackgroundImage';
import BrowserCheck from './BrowserCheck';
import Visible from './Visible';
import FooterFunFacts from './FooterFunFacts';
import Notify from './Notify';
import Placeholder from './Placeholder';
import SelectBox from './SelectBox';
import SelectBoxRelated from './SelectBoxRelated';

// Add the theme behaviors
Drupal.behavior(() => {
  // Body element
  const body = document.body;
  // Page element
  const page = document.querySelector('.page');
  if (page && !page.Visible) {
    page.Visible = new Visible(page);
  }

  // DD Template Behaviors
  if (!document.body.DDTemplates) {
    document.body.DDTemplates = new DDTemplates();
  }

  // Get browser and version
  if (body && !body.browserCheck) {
    body.browserCheck = new BrowserCheck(body);
  }

  // Fix our damn menus from displaying orphaned children
  document.querySelectorAll('.main-navigation, .term-navigation').forEach((element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Sticky sidebars
  document.querySelectorAll('.page-sidebar').forEach((element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main Navigation
  const mainMenu = document.querySelector('#nice-menu-3');
  if (mainMenu && !mainMenu.Navigation) {
    mainMenu.Navigation = new Navigation(mainMenu);
  }

  // Controls the states of the menu and search states
  const toolbar = document.querySelector('.toolbar');
  if (toolbar && !toolbar.Toolbar) {
    toolbar.Toolbar = new Toolbar(toolbar);
  }

  // Fixed Header using Headroom.js
  document.querySelectorAll('.headroom').forEach((element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Wraps each accordion element
  document.querySelectorAll('.accordion-heading').forEach((element) => {
    if (!element.accordionWrap) {
      element.accordionWrap = new AccordionWrap(element);
      element.accordionWrap = new AccordionFix(element);
    }
  });

  // Wraps each accordion in a container
  document.querySelectorAll('.node-content').forEach((element) => {
    if (!element.accordionContainer) {
      setTimeout(() => {
        element.accordionContainer = new AccordionContainer(element);
      }, 300);
    }
  });

  // Notifications
  document.querySelectorAll('.notifications').forEach((element) => {
    if (!element.notify && $(element).find('.node').length) {
      element.notify = new Notify(element);
    }
  });

  // Term Navigation
  const termNavigation = document.querySelector('.term-navigation');
  if (termNavigation && !termNavigation.TermNavigation) {
    termNavigation.TermNavigation = new TermNavigation(termNavigation);
  }

  // Footer Fun Facts Slider
  const footerFunFacts = document.querySelector('.footer-fun-facts');
  if (footerFunFacts && !footerFunFacts.slider && !footerFunFacts.visible) {
    footerFunFacts.slider = new FooterFunFacts(footerFunFacts);
    footerFunFacts.visible = new Visible(footerFunFacts);
  }

  // Calendar of Events View
  document.querySelectorAll('.calendar-feed').forEach((element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element);
    }
  });

  // Banner
  document.querySelectorAll('.banner').forEach((banner) => {
    if (!banner.BgImage) {
      banner.BgImage = new BackgroundImage(banner, {
        sourceSelector: 'figure img',
        destSelector: '.node-banner',
      });
    }
  });

  // Flyout Pod
  document.querySelectorAll('.node-flyout-pod').forEach((flyoutPod) => {
    if (!flyoutPod.BgImage) {
      flyoutPod.BgImage = new BackgroundImage(flyoutPod, {
        sourceSelector: '.field-image.c1 img',
        destSelector: '.node-image',
      });
    }
  });

  // Set placeholder of textfield using label
  document.querySelectorAll('.pods .type-textfield').forEach((element) => {
    if (!element.placeholder) {
      element.placeholder = new Placeholder(element, {
        trim: true,
      });
    }
  });

  // Find Your Employer Selection Template
  document.querySelectorAll('#block-nice_menus-4 ul.nice-menu').forEach((element) => {
    if (!element.SelectBox) {
      element.SelectBox = new SelectBox(element);
    }
  });

  // Add option for related links dropdown
  document.querySelectorAll('.ttv-standard #block-views_blocks-term-block_1-1 .node.dropdown .node-inner ul.links').forEach((element) => {
    if (!element.SelectBoxRelated) {
      element.SelectBoxRelated = new SelectBoxRelated(element);
    }
  });

  document.querySelectorAll('.node-795 #block-digitaldcore-node_fields ul.links').forEach((element) => {
    const contentEl = document.querySelector('#content');
    if (contentEl) {
      contentEl.appendChild(element);
    }
    if (!element.SelectBoxRelated2) {
      element.SelectBoxRelated2 = new SelectBoxRelated(element);
    }
  });

  // =============================================================================
  // HOME PAGE FUNCTIONALITY
  // =============================================================================

  // Home Hero Block
  let block = document.querySelector('.home-hero.block');
  if (block && !block.HomeHero && !block.BgImage && !block.visible) {
    block.HomeHero = new HomeHero(block);
    block.visible = new Visible(block);
  }

  // Homepage Quicklinks
  block = document.querySelector('.home-quicklinks');
  if (block && !block.Visible) {
    block.Visible = new Visible(block);
  }

  // =============================================================================
  // FOOTER
  // =============================================================================

  // Smart Footer
  const footer = document.querySelector('.page-footer');
  if (footer && !footer.SmartFooter && page) {
    footer.SmartFooter = new SmartFooter(footer, page);
  }
});

// If we're in development mode...
// Open up all missing images within a new tab/window.
if (process.env.NODE_ENV === 'development') {
  document.body.FetchSourceImages = new FetchSourceImages();
}
